import MinatiNFTABI from '../abi/minatinft.json';
import TokenABI from '../abi/token.json';

export const CONTRACTS = {
  NFT: {
    address: process.env.REACT_APP_CONTRACT || '0x468Dc8315EC0052945df432A080947A5Fe0552fD',
    abi: MinatiNFTABI,
  },
  TOKEN: {
    address: process.env.REACT_APP_TOKEN || '0x26E21583d200c683858C3f0dAC9cA8AC09a55292',
    abi: TokenABI,
  },
};
